import HeroSection from "@/components/sections/HeroSection";
import HomeProjects from "@/components/sections/HomeProjects";
import HomeGallery from "@/components/sections/HomeGallery";
import HomeTestimonials from "@/components/sections/HomeTestimonials";
import HomeCallToAction from "@/components/sections/HomeCallToAction";
import HomeMissoesCaatingaHighlight from "@/components/sections/HomeMissoesCaatingaHighlight";

const Index = () => {
  return (
    <div className="space-y-0">
      <HeroSection />
      <HomeMissoesCaatingaHighlight />
      <HomeProjects />
      <HomeGallery />
      <HomeTestimonials />
      <HomeCallToAction />
    </div>
  );
};

export default Index;
